import { render } from "./HoldConfirmModal.vue?vue&type=template&id=3fd1e2bc"
import script from "./HoldConfirmModal.vue?vue&type=script&lang=js"
export * from "./HoldConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__